export default "__VITE_ASSET__LF47Kz5V__"